import SkillScore from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, `${val}`];  // stringify
    default:
      return [key, val];
  }
};

const create = (data) => new SkillScore(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/AcademicInfo/SkillScore/create.js